import React from 'react';
import { classes, scrollToTop, useToggler } from '../../../lib';
import Styles from './Submenu.module.less';
import { Link } from 'react-router-dom';
import { CaretRightFilled, CaretDownFilled } from '@ant-design/icons';

export type SubmenuProps = {
    title: string;
    selected: string;
    slug: string;
    submenu: {
        slug: string;
        title: string;
    }[];
    children?: React.ReactNode;
};

export const Submenu = ({
    title,
    selected,
    slug,
    submenu,
    children,
}: SubmenuProps): JSX.Element => {
    const [isOpen, toggleMenu] = useToggler(false);
    return (
        <div className={classes(Styles.submenuContainer)}>
            <div
                className={classes(Styles.submenu, isOpen && Styles.open)}
                onClick={toggleMenu}>
                <span>
                    {isOpen ? (
                        <CaretDownFilled
                            className={classes(Styles.caret, 'td-hidden')}
                        />
                    ) : (
                        <CaretRightFilled
                            className={classes(Styles.caret, 'td-hidden')}
                        />
                    )}
                    {title}
                </span>
                <div className={classes(Styles.options)}>
                    {submenu.map((s, i) => (
                        <Link
                            key={i}
                            onClick={() => {
                                scrollToTop();
                            }}
                            to={`/${slug}/${s.slug}`}
                            className={
                                selected === s.slug ? Styles.selected : ''
                            }>
                            {s.title}
                        </Link>
                    ))}
                </div>
                {children}
            </div>
        </div>
    );
};
